module.exports = __webpack_public_path__ + "static/christina-wocintechchat-talking-at-table-700px-82e04f5d78595b600c2d6c87ab6e405b.jpg";